<template>
    <div class="album-header">
        <div class="album-header__title" @click="onClick">
            <svg-profile-header-back />
            <slot></slot>
        </div>
    </div>
</template>

<script>
// import Translations from "./insert-me-to-translate.vue";

export default {
    components: {
        SvgProfileHeaderBack: () => import(/* webpackChunkName: "chunk-svg-profile-header-back" */ '../../../svg/profile-header-back.vue'),
    },
    props: {
        goBackUrl: String,
    },
    data() {
        return {};
    },
    methods: {
        onClick() {
            if (this.goBackUrl) {
                window.location.href = this.goBackUrl;
            } else {
                window.history.go(-1);
            }
        }
    }
}
</script>

<style>
.album-header {
    width: 100%;
    display: flex;
    padding: 25px 0;
    align-items: center;
    gap: 20px;
    justify-content: space-between;
}
.album-header__title {
    display: flex;
    gap: 20px;
    align-items: center;
    cursor: pointer;
}
.album-header__title > svg {
    cursor: pointer;
}
.album-header__title > *:not(svg) {
    color: var(--color-dark);
    font-size: 16px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    letter-spacing: 0.08px;
}
</style>
